<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      addText="导出"
      :addBtnLoading="exporting"
      :handelAdd="handelExport"
      :ableSearch="ableSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="paginatedData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'result'">
          {{ codeToText(record.result, loginState) }}
        </template>
        <template v-else-if="column.key === 'depart_id'">
          {{ codeToText(record.depart_id, Enum.dept.value) }}
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getData } from '@/api/system_report/approval_count'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText } from '@/utils/format'
  import { loginState } from '@/utils/common'
  import table_data_format from '@/components/table_data_format'
  import { fileExport } from '@/utils/download'

  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    true
  )
  const ableAdd = computed(() =>
    true
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'depart_name',
      label: '企业名称',
    },
    {
      type: 'input',
      field: 'user_name',
      label: '联络人姓名',
    },
    {
      type: 'date',
      field: 'count_date',
      label: '时间',
      defaultValue: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      format: 'YYYY-MM-DD',
      allowClear: false,
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '审核日期',
      dataIndex: 'date',
      key: 'date',
      align: 'left',
    },

    {
      title: '企业名称',
      dataIndex: 'depart_name',
      key: 'depart_name',
      align: 'left',
    },
    {
      title: '姓名',
      dataIndex: 'user_name',
      key: 'user_name',
      align: 'left',
    },
    {
      title: '审核总次数',
      dataIndex: 'total',
      key: 'total',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)

  // 分页配置
  const pagination = ref({
    current: 1,
    pageSize: 10,
    total: 0,
    showLessItems: true,
    showQuickJumper: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  // 计算分页后的数据
  const paginatedData = computed(() => {
    const start = (pagination.value.current - 1) * pagination.value.pageSize
    const end = start + pagination.value.pageSize
    return tableData.value.slice(start, end)
  })

  function handleTableChange(paginationInfo) {
    pagination.value.current = paginationInfo.current
    pagination.value.pageSize = paginationInfo.pageSize
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data
      // 更新分页总数
      pagination.value.total = data.length
      // 如果当前页超出范围，重置到第一页
      const maxPage = Math.ceil(data.length / pagination.value.pageSize)
      if (pagination.value.current > maxPage && maxPage > 0) {
        pagination.value.current = 1
      }
    })
  }
  onMounted(fetch)

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExport({
      onFinally: () => (exporting.value = false),
      name: `审批统计导出.xlsx`,
      url: `/api/statistics/user_check/export?count_date=${formState.count_date}&depart_name=${formState.depart_name}&user_name=${formState.user_name}`,
    })
  }
</script>
